import { HeaderLayout } from '@/layout/Header';
import { handleMessageError } from '@/util/handleMessageError';
import { useEffect, useState } from 'react';
import { useWatch, useForm, FormProvider } from 'react-hook-form';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import Content from './Content';
import reportServer from '@/services/report.service';
import './style.scss';
import LoadingWrap from '@/components/LoadingWrap';
import moment from 'moment';
import LayoutContent from '@/layout/Content';
import { useNavigate } from 'react-router-dom';

const ProductDailyReport = () => {
    const methods = useForm<any>();
    const navigate = useNavigate();

    const [params, setParams] = useState<any>({
        day: moment().format('YYYY/MM/DD'),
        month: null,
    });
    const {
        isLoading,
        data: report,
        refetch,
    } = useQuery(['report'], () => reportServer.getReport(params), {
        enabled: !!params.day,
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    useEffect(() => {
        if (params.day) {
            refetch();
        }
    }, [params, refetch]);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);

    return (
        <>
            <LoadingWrap isLoading={isLoading}>
                <LayoutContent
                    title={'Báo cáo'}
                    className={'bao-cao'}
                    actionFilter={{
                        value: params.day,
                        onChange: (data?: any) => setParams({ day: data }),
                    }}
                />
                <div className={'l-content__wrap p-revenue'}>
                    <FormProvider {...methods}>
                        <Content data={report?.data} />
                    </FormProvider>
                </div>
            </LoadingWrap>
        </>
    );
};

export default ProductDailyReport;
